"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeError = void 0;
const lodash_1 = require("lodash");
const ERROR_NONENUMERABLE = ['name', 'message', 'code', 'stack'];
const serializeError = (error) => {
    if (typeof error == 'object') {
        error = (0, lodash_1.reduce)([...ERROR_NONENUMERABLE, ...(0, lodash_1.keys)(error)], (acc, key) => {
            if ((0, lodash_1.has)(error, key)) {
                acc[key] = error[key];
            }
            return acc;
        }, {});
    }
    return error;
};
exports.serializeError = serializeError;
//# sourceMappingURL=error.js.map